export const blockIconsHardwareLaptopChromebookNew = (
	<span className='material-symbols-outlined'>laptop_chromebook</span>
);
